import { useState } from 'react';
import IconButton from './IconButton';
import { Card, CardHeader, CardContent } from './ui/card';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Button } from './ui/button';

const CollapsibleCard = ({ title, headerButtons, headerBtnPos="right", showCollapseButton=true, showBackButton=false, handleBack=()=>{}, className, children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Card className={`bg-accent bg-opacity-25 w-full mb-2 overflow-hidden ${className}`}>
      {headerBtnPos==="right" ? <CardHeader className="flex justify-between">
        <div className='inline-flex items-center'>{title}</div>
        <div className="flex items-center space-x-2">
          { headerButtons || "" }
          {showBackButton && <Button 
                variant="default"
                size="sm"
                onClick={handleBack}
            >
            ← Back
            </Button>
          }
          {showCollapseButton && 
            <div className="md:hidden">
              <IconButton variant="collapse" size="iconsm" Icon={ChevronDownIcon} onClick={() => setCollapsed((prev) => !prev)} />
            </div>
          }
        </div>
      </CardHeader> : <CardHeader className="flex justify-between">
        <div>
          { headerButtons || "" }
          <span>{title}</span>
        </div>
        <div className={`flex items-center space-x-2`}>
          {showCollapseButton && 
            <div className="md:hidden">
              <IconButton variant="collapse" size="iconsm" Icon={ChevronDownIcon} onClick={() => setCollapsed((prev) => !prev)} />
            </div>
          }
        </div>
      </CardHeader>}
      <CardContent className={`transition-all duration-300 ease-in-out ${collapsed ? 'max-h-0 py-2' : 'max-h-[10000px]'}`}>
        {children}
      </CardContent>
    </Card>
  );
};

export default CollapsibleCard;
